import Collection from "../../data-structures/collection"

import ProjectSession from "./project-session"
import {PROJECT_PATH_SEPARATOR} from "../../gd/const/import-export/import-export"
import {ProjectSystemType} from "./types"
import DebugPerformance from "../../gd/utils/performance"
import projectSessionCollection_initTree from "./functions/init-tree"
import {EntityType} from "../../gd/const/item"
import projectSession_checkIfAvailableAsParentFor from "./functions/check-parent-for"
import {ItemDisplay} from "../item/@type";

// const debug = "ProjectSessionCollection"
const debug = false

const debugPerformance = false

type GetChildrenOptions = {
    sort?           : 'func' | null
    sortFunction?   : func
}

// Important (!!!!!)
// I've added support for tree but not using it entirely - just in some cases (optimizedMethods(
// what we really need is reset tree and monitor changes (!) and reset again on any project delta !!!
// this way it will be lightning fast , however evn current temp usage of tree speeds up dramatically !




export default class ProjectSessionCollection extends Collection<ProjectSession> {

    // cartefull - not initialized unless reset tree
    public treeRoots        : ProjectSession[] = [] // ya tak ponimau tut mi hranim vse nashi root projects session...

    constructor(models:ProjectSession[]) {
        super(models)
    }

    static initFromJson(data:JSONArray) {
        const collection = new ProjectSessionCollection([])

        _.map(data, (record:any)=>{
            collection.add(new ProjectSession(record))
        })

        // collection.sort()

        return collection
    }

    // Start TREE

    initTree() {
        debug && console.log(debug, "initTree()")
        debugPerformance && DebugPerformance.start("initTree")
        projectSessionCollection_initTree(this)
        debugPerformance && DebugPerformance.stop("initTree")
    }

    public clearTree() {
        this.treeRoots = []

        _.map(this.models, (project)=> {
            project.treeChildren   = [];
            project.treeParent     = undefined
        })
    }

    // End TREE


    map(callback: {(project:ProjectSession):void}) {
        return _.map(this.models, callback)
    }

    addMany(projects:ProjectSession[]) {
        _.map(projects, (project:ProjectSession)=>{
            this.add(project)
        })
    }

    // FROM OLD SESSION

    // SUPER puper hack by Vic
    // problem - sometimes we need template i.e. find missing
    // but it is not in collection (!) so wee need to check session.projectTemplates as well
    get(id: ID | null | undefined):ProjectSession | null {

        // prevent TS errors
        if (!id) return null

        const project = this.byId[id]

        if (!project) {
            return gd.session.templatesList.get(id)
        }

        return project
    }

    resetAndKeepOldModels(data:any) {
        const previousCollectionModels = _.clone(this.models)

        const models: ProjectSession[] = []
        _.map(data, (record:any)=>{
            models.push(new ProjectSession(record))
        })

        this.reset(models)

        // add models that are missing in new session Collection
        _.map(previousCollectionModels, model => {
            if (!this.get(model.id)) {
                this.add(model)
            }
        })

        this.initTree()
    }

    _filter(filterFunction: {(project: ProjectSession):boolean}):ProjectSessionCollection {
        const filteredModels: ProjectSession[] = _.filter(this.models, filterFunction) as ProjectSession[]

        return new ProjectSessionCollection(filteredModels)
    }

    filterNewTaskProjects() {
        return this._filter((project: ProjectSession) => {
            return !project.isArchived && !!project.role
        })
    }

    filterAvailableProjects(projectIdsToExclude?: ID[]):ProjectSessionCollection {
        return this._filter((project: ProjectSession) => {
            return !projectIdsToExclude?.includes(project.id)
        })
    }

    /*openProjects() {
        return new ProjectCollectionSession(this.filter(function(project){
            return (!project.isArchived);
        }));
    }*/

    filterByCompany(companyId: ID) {
        return this._filter((project: ProjectSession) => {
            return project.companyId===companyId
        })
    }

    exportToOptions() {
        return this.exportList()
    }

    search(q:string) : ProjectSession[] {
        return _.filter(this.models, (project: ProjectSession) => {
            return !project.isTemplate && project.access && project.name.toLowerCase().indexOf(q) > -1
        })
    }

    treeSearch(query:string, parentFor?: EntityType[], availableProjects?: ProjectSessionCollection) : void {

        const visibleProjects : ProjectSession[] = []
        const searchString = query.toLowerCase()

        _.map(this.models, (project: ProjectSession) => {
            if (!project.isTemplate &&
                project.access &&
                project.name.toLowerCase().includes(searchString) &&
                (!parentFor || projectSession_checkIfAvailableAsParentFor(project, parentFor)) &&
                (!availableProjects || availableProjects?.get(project.id))) {
                project.treeDisplay = ItemDisplay.VISIBLE
                visibleProjects.push(project)
                return
            }

            project.treeDisplay = ItemDisplay.HIDDEN

        })

        // now let's mark parents as ghosts
        _.forEach(visibleProjects, project => {
            project.markParentsAsVisibleGhosts()
        })

    }

    findCompanyProjectsForTree(companyId:ID, options: any = {}) {
        const { includeArchived, includeTemplates } = options;
        const result : any[] = [];

        const company = gd.session.companies.get(companyId)

        _.map(this.models, (project: ProjectSession) => {
            if ((!project.isTemplate || includeTemplates) &&
                project.companyId === companyId &&
                (includeArchived || project.systemStatus < gd.const.systemStatus.COMPLETED) &&
                (company.settings.projectAccess.showParentsDespiteAccess || project.access)) {

                result.push({
                    access          : project.access,
                    color           : project.color,
                    companyId       : project.companyId,
                    // customFields
                    // icon
                    id              : project.id,
                    name            : project.name,
                    parentId        : project.parentId,
                    // role
                    // shortName
                    // systemStatus
                    sortPosition    : project.sortPosition,
                    systemType      : project.systemType
                })
            }
        })

        return result
    }

    allTags() {
        return this.filterBySystemType(gd.const.project.type.TAG)
    }

    filterBySystemType(systemType: ProjectSystemType){
        return this._filter((project: ProjectSession) => {
            return project.systemType === systemType
        })
    }


    // Optimized (perfrormance) methods

    // In some cases in can be slow like 1s+ ....
    getAllChildrenOptimized(projectId?: ID, options: GetChildrenOptions = {}):ProjectSession[] {
        debug && console.log(debug, "getAllChildrenOptimized() projectId=", projectId, "options=", options)

        debugPerformance && DebugPerformance.start("getAllChildrenOptimized")

        this.initTree()

        const collectChildren = (projects: ProjectSession[])=>{

            let collectRes: ProjectSession[] = []

            _.map(projects, (project: ProjectSession)=>{
                if (!project) return // skip children collection if no project

                // add project to result
                collectRes.push(project)

                // find all children of this project
                let childrenProjects : ProjectSession[] = project.treeChildren

                // do nothing if no children found
                if (!_.isEmpty(childrenProjects)) {
                    // sort all children of this project if necessary
                    switch(options.sort) {
                        case 'func':
                            if (options.sortFunction) {
                                childrenProjects = options.sortFunction(childrenProjects)
                            }
                            break
                    }

                    // collect children for every child of this project
                    collectRes = collectRes.concat(collectChildren(childrenProjects))
                }
            })

            return collectRes
        }

        // const projects: ProjectSession[] = projectId ? [this.get(projectId)] as ProjectSession[] : _.filter(this.models, model=>!model.parentId) // if no projectId then get all root projects
        let res             : ProjectSession[] = []
        let initialProjects : ProjectSession[] = projectId ? [this.get(projectId)!] : this.treeRoots

        res = collectChildren(initialProjects)

        debugPerformance && DebugPerformance.stop("getAllChildrenOptimized")
        return res
    }

    // I think it's fast
    getAllParents(projectId: ID):ProjectSession[] {

        const res: ProjectSession[] = [];
        const project = this.get(projectId);

        const collectParent = (parentId: ID | null) => {
            if (parentId) {
                const parent = this.get(parentId)
                if (parent) {
                    res.push(parent)
                    collectParent(parent.parentId)
                }
            }
        }

        if (project) collectParent(project.parentId)

        return res.reverse()
    }

    // I think ti's fast
    getAllParentsIds(projectId: ID):ID[] {
        const res: ID[] = []
        const project = this.get(projectId)

        const collectParent = (parentId: ID | null) => {
            if (parentId) {
                res.push(parentId)
                const parent = this.get(parentId)
                if (parent) {
                    collectParent(parent.parentId)
                }
            }
        }

        if (project) collectParent(project.parentId)

        return res.reverse()
    }

    // Collect all chained projects by treeParent and treeChildren, starting from projectIds
    getAllInvolvedProjectsIds(projectIds: ID[]) {
        const resultIds = new Set<ID>()
        const stack: ProjectSession[] = []

        // Helper to add project and its treeParent chain
        const addParentChain = (project: ProjectSession | null) => {
            let currentProject: ProjectSession | null | undefined = project
            while (currentProject && !resultIds.has(currentProject.id)) {
                resultIds.add(currentProject.id)
                currentProject = currentProject.treeParent
            }
        }

        // Initialize stack and parent chains
        _.map(projectIds, (id: ID) => {
            const project = this.get(id)
            if (project) {
                addParentChain(project)
                stack.push(project)
            }
        })

        // Traverse treeChildren for all discovered projects
        while (stack.length > 0) {
            const current = stack.pop()
            if (!current) continue
            _.map(current.treeChildren, (child: ProjectSession) => {
                if (child && !resultIds.has(child.id)) {
                    addParentChain(child)
                    stack.push(child)
                }
            })
        }

        return Array.from(resultIds)
    }

    exportList() {
        return _.map(this.models, (project: ProjectSession) => {
            return {
                'value'     : project.id,
                'label'     : project.name,
                // 'icon'      : project.iconNormal, // there were no such parameter in old ProjectModelSession (only in project-basic.js)
                'iconObj'   : project
            }
        })
    }

    // search project by NAME > NAME > NAME making sure we have all parents
    findByFullPath(projectPath:string) {

        const parts         = projectPath.split(PROJECT_PATH_SEPARATOR)

        let currentParent   : ProjectSession | undefined
        let project         : ProjectSession | undefined
        let notFound        : boolean        = false

        _.map(parts, name => {
            name = name.trim()

            // const currentParentName = currentParent ? currentParent.name : '---'
            // console.log("project name =", name, "currentParent", currentParentName)

            if (!_.isNil(currentParent)) {
                project = _.find(this.models, model=>{
                    return model.parentId === currentParent?.id && model.name.trim() === name
                })
                if (!project) notFound = true
                currentParent = project || undefined
            } else {
                project = _.find(this.models, model=>{
                    return !model.parentId && model.name.trim() === name;
                })
                if (!project) notFound = true
                currentParent = project || undefined
            }

            // console.log(name, "->", project)
        })

        if (notFound) return false
        else return project
    }



    // Below not optimized ?





    // In some cases in can be slow like 1s+ ....
    getAllChildren(projectId: ID | undefined, options: GetChildrenOptions = {}):ProjectSession[] {

        console.warn("#kdjd92348 THIS is not Optimized in very slow - use optmized above ")

        if (!projectId) return []

        debug && console.log(debug, "getAllChildren() projectId=", projectId, "options=", options)

        let res = []

        const collectChildren = (projects: ProjectSession[])=>{

            let collectRes: ProjectSession[] = []
            _.map(projects, (project: ProjectSession)=>{
                if (!project) return // skip children collection if no project

                // add project to result
                collectRes.push(project)

                // find all children of this project
                let children = _.filter(this.models, model=>model.parentId === project.id)

                // do nothing if no children found
                if (!_.isEmpty(children)) {
                    // sort all children of this project if necessary
                    switch(options.sort) {
                        case 'func':
                            if (options.sortFunction) {
                                children = options.sortFunction(children)
                            }
                            break
                    }

                    // collect children for every child of this project
                    collectRes = collectRes.concat(collectChildren(children))
                }
            })

            return collectRes
        }

        // const projects: ProjectSession[] = projectId ? [this.get(projectId)] as ProjectSession[] : _.filter(this.models, model=>!model.parentId) // if no projectId then get all root projects

        let initialProjects : ProjectSession[] = []
        if (projectId) {
            initialProjects = [this.get(projectId)!]
        } else {
            // if no projectId then get all root projects for the organization...
            // not 100% sure we use it because of param (!) but we can use it outside ot TS
            initialProjects = _.filter(this.models, model=>!model.parentId)
        }


        res = collectChildren(initialProjects)

        return res
    }

    get hasProjectsOutsideOfWorkspace():boolean {
        let result = false

        _.map(this.treeRoots, (project)=>{
            if ((gd.user.acl.isClient || !project.isWorkspace) &&
                !project.isView &&
                !project.isTag &&
                (project.hasAccess || project.hasAccessibleChildren)) {
                result = true
            }
        })

        return result
    }

    get treeRootsNotWorkspaces():ProjectSession[] {

        /*return _.filter(this.treeRoots, (project)=>{
            return !project.isWorkspace && !project.isTag
        })*/

        const projects : ProjectSession[] = []

        const addRootProject = (project:ProjectSession) => {
            // add as root project if it belongs to projects, is not tag and user has access to it or option showParentsDespiteAccess is enabled
            if (project.space.id === gd.spaces.projects.id && !project.isTag && !project.isSection && (gd.company.settings.projectAccess.showParentsDespiteAccess || project.hasAccess)) {
                projects.push(project)
            } else {
                recursiveLookForRootProjects(project)
            }
        }

        const recursiveLookForRootProjects = (projectSession: ProjectSession) => {
            _.map(projectSession.treeChildren, (childProject:ProjectSession)=> {
                addRootProject(childProject)
            })
        }

        // look for first accessible project down the tree for each treeRoots and add it as root project
        _.map(this.treeRoots, (rootProject: ProjectSession) => {
            addRootProject(rootProject)
        })

        return projects
    }

    get treeRootsSections():ProjectSession[] {
        return _.filter(this.treeRoots, (project)=>{
            return project.isSection
        })
    }

    get workspaces():ProjectSession[] {

        return _.filter(this.treeRoots, (project)=>{
            return project.isWorkspace
        })
    }

    get rootTags():ProjectSession[] {
        return _.filter(this.treeRoots, (project:ProjectSession)=>{
            return project.isTag
        })
    }

    get allParentsIdsInSession(){
        return _.filter(this.models, (project)=>!_.isEmpty(project.treeChildren))
            .map((project:ProjectSession)=>project.id)
    }

    get companyHasNoProjects() : boolean {

        return (_.isEmpty(this.treeRoots))

        const notTemplate = _.find(this.models, (project:ProjectSession)=>{
            return !project.isTemplate
        })

        return !notTemplate
    }

    get crmProjects():ProjectSession[] {
        return _.filter(this.models, (project:ProjectSession)=>{
            return !!project.crmAccountId
        })
    }
}
